import { createCheckoutI18nController } from '@gig/checkout-shared-i18n';
import { LitElement } from 'lit';
import { checkoutI18n } from './localization.js';

export class CheckoutI18nLitElement extends LitElement {
  protected readonly checkoutI18nController = createCheckoutI18nController(this, checkoutI18n);
}
